import { render } from "./WhoAlphaLabs02.vue?vue&type=template&id=2f2e89f7&scoped=true"
const script = {}

import "./WhoAlphaLabs02.vue?vue&type=style&index=0&id=2f2e89f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2e89f7"]])

export default __exports__